export default function ProgressSteps({ step, total = 4 }: { step: number; total?: number }) {
  const bars = Array.from({ length: total });
  return (
    <div className="flex items-center gap-6">
      {bars.map((_, index) => (
        <div
          key={index}
          className="h-2 rounded-full"
          style={{ width: 120, backgroundColor: index < step ? "#00553E" : "#D1E2DD" }}
        />
      ))}
    </div>
  );
}

